import { Component, OnInit, Input } from '@angular/core';
import { ModalController, ToastController, LoadingController, AlertController } from '@ionic/angular';
import { CalibrationService } from 'src/app/calibration/calibration.service';
import { TranslationService } from 'src/app/shared/services/translation.service';
import { BaseClass } from 'src/app/shared/classes/base';
import { UsersService } from 'src/app/users/users.service';

@Component({
  selector: 'app-import-visibility-participants',
  templateUrl: './import-visibility-participants.component.html',
  styleUrls: ['./import-visibility-participants.component.scss'],
})
export class ImportVisibilityParticipantsComponent extends BaseClass implements OnInit {

  public data: string;
  public replace: boolean = false;
  @Input() cycleId: any;

  constructor(
    protected _toastController: ToastController,
    protected _translationService: TranslationService,
    private _loadingController: LoadingController,
    private _modalController: ModalController,
    private _alertController: AlertController,
    private _usersService: UsersService ) {
      super(_toastController, _translationService);
    }

  ngOnInit() {}

  private dismiss(data?: any) {
    this._modalController.dismiss(data);
  }

  public async send(): Promise<void> {
    const loading = await this._loadingController.create();
    await loading.present();

    this._usersService.importVisibilityParticipants(this.cycleId, this.data)
    .subscribe(
      response => {
        loading.dismiss();
        this.dismiss([response.data, this.replace]);
    }, error => {
      loading.dismiss();
      this.notifyError(error);
    });
  }

  public cancel() {
    this.dismiss();
  }
}
